import cookieStorage from '../features/cookie'

export const setMerchantIdAndCountryCodeCookies = (id, countryCode) => {
	cookieStorage.setItem('currentMerchantID', id)
	cookieStorage.setItem('currentMerchantCountryCode', countryCode)
}

// Get the country code of the selected merchant
export const getCurrentMerchantCountryCode = () => {
	return cookieStorage.getItem('currentMerchantCountryCode')
}
